import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import menuUI from './menu/ui';
import mainUI from "./modules/main/ui";
import mainData from "./modules/main/data";
import auth from './auth';
import loyalty from './loyalty';
import ui from './ui';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        menuUI,
        mainUI,
        mainData,
        auth,
        loyalty,
        ui,
    },

    plugins: [
        createPersistedState({
            key: 'vuex',
            paths: ['auth'] // Исключаем loyalty из persisted state, чтобы избежать проблем с кешированием при смене пользователя
        })
    ]
});
